import { render, staticRenderFns } from "./HostedPageBanner.vue?vue&type=template&id=0c415a9c&scoped=true&"
import script from "./HostedPageBanner.vue?vue&type=script&lang=js&"
export * from "./HostedPageBanner.vue?vue&type=script&lang=js&"
import style0 from "./HostedPageBanner.vue?vue&type=style&index=0&id=0c415a9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c415a9c",
  null
  
)

export default component.exports